import { render, staticRenderFns } from "./en.vue?vue&type=template&id=fb10dc7a&scoped=true&"
import script from "./en.vue?vue&type=script&lang=js&"
export * from "./en.vue?vue&type=script&lang=js&"
import style0 from "./en.vue?vue&type=style&index=0&id=fb10dc7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb10dc7a",
  null
  
)

export default component.exports